var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Hero'),_c('main',[_c('Logo'),_c('Studio',{attrs:{"scroller":"right"}}),_c('Gallery',{attrs:{"scroller":"left"}}),_c('Team'),_c('Contact',{attrs:{"scroller":"left"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }